import axios from 'axios';
import { getTokenSilent } from './auth';
import Constants from './constants';

function interceptors(baseApiUrl, msalInstance, scopes) {
  const axiosInstance = axios.create({
    baseURL: baseApiUrl,
  });

  axiosInstance.interceptors.request.use((config) => {
    const selectedRole = JSON.parse(sessionStorage.getItem('selectedPathwayRole'));
    const formatRole = selectedRole?.toLowerCase().replaceAll('"', '');
    console.log(formatRole, 'formatRole');
    console.log(config.url, 'url list');
    const roleExceptionApi = ['/application_access', '/user_roles', '/get_user_image'];

    return getTokenSilent(msalInstance, scopes)
      .then((token) => {
        if (
          !roleExceptionApi.some((endPoint) => endPoint === config.url) &&
          !config.url.includes('user_roles') &&
          !config.url.includes('get_user_image') &&
          !config.url.includes('application_access')
        ) {
          config.headers.Authorization = `Bearer ${token}`;
          config.headers.environment = Constants.stagingEnv;
          config.headers['Ocp-Apim-Subscription-Key'] = Constants.apimSubscriptionKey;
          config.headers['current-role'] = `cs-${formatRole}`;
          return Promise.resolve(config);
        }
        config.headers.Authorization = `Bearer ${token}`;
        config.headers.environment = Constants.stagingEnv;
        config.headers['Ocp-Apim-Subscription-Key'] = Constants.apimSubscriptionKey;
        return Promise.resolve(config);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      console.log(error, 'API error');
      const { config } = error;
      if (!config.__retryCount) config.__retryCount = 0;

      if (config.__retryCount < 3) {
        config.__retryCount += 1;
        await new Promise((res) => setTimeout(res, 1000 * config.__retryCount)); // Exponential backoff
        return axiosInstance(config);
      }

      return Promise.reject(error);
    },
  );

  return axiosInstance;
}

export class API {
  constructor(baseApiUrl, msalInstance, scopes) {
    this.axios = interceptors(baseApiUrl, msalInstance, scopes);
  }

  GET(url, data) {
    return this.axios.get(url, {
      params: data,
    });
  }

  POST(url, data, config) {
    return this.axios.post(url, data, config);
  }

  DELETE(url) {
    return this.axios.delete(url);
  }

  PUT(url, data) {
    return this.axios.put(url, data);
  }
}
